import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // timeout: 2000, // 2 seconds timeout
});

axiosInstance.interceptors.request.use((config) => {
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    let errorMessage = 'An error occurred';

    if (error.response) {
      console.error('Response Error:', {
        status: error.response.status,
        message: error.response.data,
      });
      errorMessage = error.response.data || error.message;
    } else if (error.request) {
      console.error('Request Error: No response received', error.request);
      errorMessage = 'No response from the server';
    } else {
      console.error('General Error:', error.message);
      errorMessage = error.message;
    }

    return Promise.reject({ ...error, message: errorMessage });
  }
);


export default axiosInstance;
